export default "__VITE_ASSET__5CQ2Ab4B__"